<template>
  <div class="admin-list" ref="main">
    <el-card class="admin-user-box" v-if="voiceRoomDetail">
      <div slot="header" class="clearfix">
        <span>廳管理員</span>
        <el-button
          style="float: right; padding: 3px 0"
          type="text"
          @click="addAdmin()"
          >新增管理員</el-button
        >
      </div>
      <el-table
        :max-height="$refs.main ? $refs.main.offsetHeight - 100 : 600"
        :data="adminUsers"
        border
        style="width: 100%"
      >
        <el-table-column prop="nickname" label="暱稱" min-width="120">
        </el-table-column>
        <el-table-column prop="uuid" label="uuid" min-width="120">
        </el-table-column>
        <el-table-column prop="avatarUrl" label="頭像" min-width="120">
          <template slot-scope="scope">
            <el-image
              style="width: 80px; height: 80px"
              :src="scope.row.avatarUrl"
              :preview-src-list="[scope.row.avatarUrl]"
              fit="cover"
            >
            </el-image>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" min-width="120">
          <template slot-scope="scope">
            <!-- <el-button @click="handleClick(scope.row)" type="text" size="small"
            >查看</el-button
          > -->
            <el-button
              type="danger"
              size="small"
              @click="deleteAdmin(scope.row, scope.$index)"
              >刪除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog
      title="添加管理員"
      :visible.sync="dialogVisible"
      width="320px"
      append-to-body
    >
      <el-input
        v-model="adminUserUuid"
        :placeholder="'請輸入用戶ID'"
        clearable
        @input="getUser()"
        style="margin-bottom:20px"
      />
      <div v-loading="getUserLoading">
        <div v-if="adminUser && adminUser.uuid">
          <el-image
            style="width: 100px; height: 100px;margin-bottom:10px "
            fit="cover"
            :src="adminUser.avatarUrl"
          >
          </el-image>
          <div>{{ adminUser.nickname }}</div>
        </div>
        <div v-else>未查找到用戶</div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" :disabled="!adminUser.uuid" @click="submitAdd"
          >確 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'AdminList',
  props: {
    isWhiteUser: {
      type: Boolean,
      default: false
    },
    voiceRoomDetail: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      adminUserUuid: '',
      adminUser: {},
      dialogVisible: false,
      getUserLoading: false,
      tableLoading: false,
      addLoading: false
    };
  },
  computed: {
    tableHeight() {
      if (this.$refs.main && this.refs.header) {
        return (
          this.$refs.main.offsetHeight - this.$refs.header.offsetHeight - 10
        );
      } else {
        return 600;
      }
    },
    adminUsers() {
      return this.voiceRoomDetail.adminUsers || [];
    },
    roomUid() {
      return this.voiceRoomDetail.roomUid || '';
    }
  },
  methods: {
    deleteAdmin(user, index) {
      const { uuid, nickname } = user;
      this.$confirm({
        content: `確定要將${nickname}從管理員中刪除嗎`,
        title: '提示',
        showCancelButton: true,
        confirmButtonText: '確定',
        closeOnClickModal: false
      }).then(() => {
        this.$http
          .get('/voiceRoom/admin/unsetAdmin', {
            roomUid: this.roomUid,
            uuid
          })
          .then(() => {
            this.adminUsers.splice(index, 1);
            this.$message.success('刪除成功');
          });
      });
    },
    addAdmin() {
      if (!this.roomUid) {
        return;
      }
      this.addUuid = '';
      this.adminUser = {};
      this.dialogVisible = true;
    },
    submitAdd() {
      this.$http
        .get('/voiceRoom/admin/setAdmin', {
          roomUid: this.roomUid,
          uuid: this.adminUser.uuid
        })
        .then(() => {
          this.dialogVisible = false;
          this.$message.success('添加成功');
          this.$emit('add-admin-success');
        });
    },
    getUser() {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
      this.timeout = setTimeout(() => {
        this.getUserLoading = true;
        this.$http
          .get('/user/detail/info', { uuid: this.adminUserUuid })
          .then(({ data }) => {
            this.adminUser = data || {};
            this.getUserLoading = false;
          })
          .catch(() => {
            this.adminUser = {};
            this.getUserLoading = false;
          });
      }, 1500);
    },
    editVoiceRoom() {
      if (!this.roomUid) {
        return;
      }
      this.$refs.editForm.open();
    },
    editVoiceRoomSuccess() {
      this.$emit('edit-voice-room-success');
    }
  },
  created() {}
};
</script>
<style lang="scss" scoped>
.admin-list {
  height: 100%;
  flex: 1;
}
</style>
